var map = {
	"./BlogArticles/Includes/BlogArticlePreview.ss": 22,
	"./CookieApproval/Includes/CookieApproval.ss": 23,
	"./CookieApproval/Includes/CookieApprovalRevokeButton.ss": 24,
	"./DevHelpers/Includes/DevSign.ss": 25,
	"./Includes/Breadcrumbs.ss": 26,
	"./Includes/Footer.ss": 27,
	"./Includes/Header.ss": 28,
	"./Includes/HomeHeader.ss": 29,
	"./Includes/Navigation.ss": 30,
	"./Includes/NoScript.ss": 31,
	"./Includes/RecentNewsSection.ss": 32,
	"./Includes/SEOTextSection.ss": 33,
	"./Includes/ToTopButton.ss": 34,
	"./Layout/BlogArticleHolderPage.ss": 35,
	"./Layout/BlogArticlePage.ss": 36,
	"./Layout/ContactPage.ss": 37,
	"./Layout/HomePage.ss": 38,
	"./Layout/IdeaPage.ss": 39,
	"./Layout/ImprintPage.ss": 40,
	"./Layout/Page.ss": 41,
	"./Layout/PrivacyPage.ss": 42,
	"./Layout/ProductGroupPage.ss": 43,
	"./Layout/ProductPage.ss": 44,
	"./Page.ss": 45,
	"./Products/Includes/ProductDescription.ss": 46,
	"./Products/Includes/ProductDetailsAccordion.ss": 47,
	"./Products/Includes/ProductImagesSlider.ss": 48,
	"./Products/Includes/ProductNavigation.ss": 49,
	"./Products/Includes/ProductPreview.ss": 50,
	"./Products/Includes/ProductPrice.ss": 51,
	"./Products/Includes/ProductSharing.ss": 52,
	"./Products/Includes/ProductTitle.ss": 53,
	"./Security_changepassword.ss": 54,
	"./Security_login.ss": 55,
	"./Security_lostpassword.ss": 56
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21;


//////////////////
// WEBPACK FOOTER
// ./src/templates \.ss$
// module id = 21
// module chunks = 0 1